/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


$(document).ready(function(){
   $('.hc-slider').slick({
      centerMode: true,
      slidesToShow: 4,
      arrows: false,
      initialSlide: 2,
      responsive: [
        {
          breakpoint: 768,
          settings: { slidesToShow: 3 }
        },
        {
          breakpoint: 480,
          settings: { slidesToShow: 1 }
        }
      ]
   });
});

$('#sel-contact').on('change', function () {
  console.log('ttr')
  var targ = $(this).val();
  console.log(targ)
  if (targ == "new") {
    var url = '/'; 
    if (url) { // require a URL
        window.location.href = '/pages/homedelivery';
    }
    return false;
  }
  else if (targ == "store") {
    
    var url = '/'; 
    if (url) { // require a URL
        window.location.href = '/pages/store-questions';
    }
    return false;
    // var url = '/'; 
    // if (url) { // require a URL
    //     window.location.href = '/collections/all';
    // }
    // return false;
    
  }
  else if (targ == "water") {
    var url = '/'; 
    if (url) { // require a URL
      window.location.href = '/pages/report-water-quality';
    }
    return false;
    
      }
  else if (targ == "water report") {
    var url = '/'; 
    if (url) { // require a URL
      window.location.href = 'https://cdn.shopify.com/s/files/1/0282/3870/8845/files/2023_Water_Quality_Report.pdf';
    }
    return false;
    
  }
  else if (targ == "service") {
    // $('.contact-step-first').hide();
    // $('.contact-step-form').show();
    // $('.contact-step-form').addClass('show');
    var url = '/'; 
    if (url) { // require a URL
        window.location.href = '/pages/find-your-distributor';
    }
    return false;
    
  }
  else if (targ == "other") {
    
    $('.contact-step-first').hide();
    $('.contact-step-form').show();
    $('.contact-step-form').addClass('show');

  }

});

$(document).ready(function() {

  if($('.home-premise-footer').length) {
    var phonex = $('.phone-number').text(); 
    $('.home-premise-footer .phone-footer').text(phonex);
    $('.home-premise-footer .phone-footer').prop({
      href: 'tel:' + phonex
    });
  }
  
//   $("#premise-form-header").submit(function(event) {
//     var $form = $(this);
//     if($form.data('zipValidated')) {
//       // zip has been validated.  Submit form regularly
//       return true;
//     }
//     var inputZip = $('#premise-form-header').find('input#zipcode').val().replace(/\s/g,'');
//     var endpoint = "https://mvsleadmanager.com/api/v1/distributor/zip" + inputZip;
    
//     $.ajax({
//       url: endpoint,
//       type: "GET",
//       dataType: "JSON",
//       success: function (data) {
//         if(data.distributor ) {
//           // zip has been validated.  Resubmit.
//           $form.data('zipValidated', true);
//           $("#premise-form-header").submit();
//         } else {
//           console.log('no data', data)
//           window.location.replace("https://www.mountainvalleyspring.com/pages/no-distributor");
//         }
//       },
//       error: function (error) {
//         event.preventDefault();
//         event.stopPropagation();
//         console.log(error);
//       //  window.location.replace("https://www.mountainvalleyspring.com/pages/no-distributor");
//       }
//     });
    
//     // abort the standard submit handler.  If we got here
//     // we haven't validated the zip yet.
//     return false;
//   });

//   $("#premise-submit-header").click(function(e) {
//         var wrap = $(this).parent().parent().parent();
//         var inputZip = $('#premise-form-header').find('input#zipcode').val();
//         var endpoint = "https://mvsleadmanager.com/api/v1/distributor/zip" + inputZip;
        
//         var requestOptions = {
//           method: 'GET',
//           redirect: 'follow'
//         };
        
//         fetch(endpoint, requestOptions)
//           .then((response) => response.text())
//           .then((result) => {
//             var res = JSON.parse(result),
//               companyId = res.distributor.distributor.id,
//               companySrc = res.distributor.distributor.company,
//               localZip = res.user_zip.zipcode.zipcode;

//             var comp2 = companySrc.replace(/[^a-zA-Z ]/g, "");
//             console.log(comp2);

//             var company = comp2,
//               comp = company.split(" ").join("-"),
//               tolo = comp.toLowerCase();

// //             window.location.replace(
// //               "/a/distributors/" + companyId + "/" + tolo + "/" + localZip);
// //             console.log("oks");
          
//              $("#premise-form-header").submit(function () {});
//           })
//           .catch((error) => {
            
//             window.location.replace("https://www.mountainvalleyspring.com/pages/no-distributor");
//           });
//   });

//   $("#premise-form-footer").submit(function(event) {
//     var $form = $(this);
//     if($form.data('zipValidated')) {
//       // zip has been validated.  Submit form regularly
//       return true;
//     }
//     var inputZip = $('#premise-form-footer').find('input#zipcode').val().replace(/\s/g,'');
//     var endpoint = "https://mvsleadmanager.com/api/v1/distributor/zip" + inputZip;
    
//     $.ajax({
//       url: endpoint,
//       type: "GET",
//       dataType: "JSON",
//       success: function (data) {
//         if(data.distributor ) {
//           // zip has been validated.  Resubmit.
//           $form.data('zipValidated', true);
//           $("#premise-form-footer").submit();
//         } else {
//           console.log('no data', data)
//           window.location.replace("https://www.mountainvalleyspring.com/pages/no-distributor");
//         }
//       },
//       error: function (error) {
//         event.preventDefault();
//         event.stopPropagation();
//         console.log(error);
//       //  window.location.replace("https://www.mountainvalleyspring.com/pages/no-distributor");
//       }
//     });
    
//     // abort the standard submit handler.  If we got here
//     // we haven't validated the zip yet.
//     return false;
//   });

//   $("#premise-submit-footer").click(function(e) {
//     var wrap = $(this).parent().parent().parent();
//         var inputZip = $('#premise-form-footer').find('input#zipcode').val();
//         var endpoint = "https://mvsleadmanager.com/api/v1/distributor/zip" + inputZip;
        
//         var requestOptions = {
//           method: 'GET',
//           redirect: 'follow'
//         };
        
//         fetch(endpoint, requestOptions)
//           .then((response) => response.text())
//           .then((result) => {
//             var res = JSON.parse(result),
//               companyId = res.distributor.distributor.id,
//               companySrc = res.distributor.distributor.company,
//               localZip = res.user_zip.zipcode.zipcode;

//             var comp2 = companySrc.replace(/[^a-zA-Z ]/g, "");
//             console.log(comp2);

//             var company = comp2,
//               comp = company.split(" ").join("-"),
//               tolo = comp.toLowerCase();

// //             window.location.replace(
// //               "/a/distributors/" + companyId + "/" + tolo + "/" + localZip);
// //             console.log("oks");
          
//              $("#premise-form-footer").submit(function () {});
//           })
//           .catch((error) => {
            
//             window.location.replace("https://www.mountainvalleyspring.com/pages/no-distributor");
//           });
//   });

//   $("#premise-form-on-premise").submit(function(event) {
//     var $form = $(this);
//     if($form.data('zipValidated')) {
//       // zip has been validated.  Submit form regularly
//       return true;
//     }
//     var inputZip = $('#premise-form-on-premise').find('input#zipcode').val().replace(/\s/g,'');
//     var endpoint = "https://mvsleadmanager.com/api/v1/distributor/zip" + inputZip;
    
//     $.ajax({
//       url: endpoint,
//       type: "GET",
//       dataType: "JSON",
//       success: function (data) {
//         if(data.distributor ) {
//           // zip has been validated.  Resubmit.
//           $form.data('zipValidated', true);
//           $("#premise-form-on-premise").submit();
//         } else {
//           console.log('no data', data)
//           window.location.replace("https://www.mountainvalleyspring.com/pages/no-distributor");
//         }
//       },
//       error: function (error) {
//         event.preventDefault();
//         event.stopPropagation();
//         console.log(error);
//       //  window.location.replace("https://www.mountainvalleyspring.com/pages/no-distributor");
//       }
//     });
    
//     // abort the standard submit handler.  If we got here
//     // we haven't validated the zip yet.
//     return false;
//   });

//   $("#premise-submit-on-premise").click(function(e) {
//         var wrap = $(this).parent().parent().parent();
//         var inputZip = $('#premise-form-on-premise').find('input#zipcode').val();
//         var endpoint = "https://mvsleadmanager.com/api/v1/distributor/zip" + inputZip;
        
//         var requestOptions = {
//           method: 'GET',
//           redirect: 'follow'
//         };
        
//         fetch(endpoint, requestOptions)
//           .then((response) => response.text())
//           .then((result) => {
//             var res = JSON.parse(result),
//               companyId = res.distributor.distributor.id,
//               companySrc = res.distributor.distributor.company,
//               localZip = res.user_zip.zipcode.zipcode;

//             var comp2 = companySrc.replace(/[^a-zA-Z ]/g, "");
//             console.log(comp2);

//             var company = comp2,
//               comp = company.split(" ").join("-"),
//               tolo = comp.toLowerCase();

// //             window.location.replace(
// //               "/a/distributors/" + companyId + "/" + tolo + "/" + localZip);
// //             console.log("oks");
          
//              $("#premise-form-on-premise").submit(function () {});
//           })
//           .catch((error) => {
            
//             window.location.replace("https://www.mountainvalleyspring.com/pages/no-distributor");
//           });
//   });


//Updated Lookup Logic
const elUTMParams = document.getElementsByName("UTM_Params__c");
elUTMParams.forEach((element, index) => {
    element.value = window.location.search; // Set the value dynamically for each element
});

// Function to handle ZIP code lookup and populate hidden fields
const handleZipLookup = (inputZip, form) => {
  const endpoint = `https://dist-lookup.fly.dev/getDistributor?zipCode=${inputZip}`;
  const requestOptions = {
    method: 'GET',
    redirect: 'follow'
  };

  return fetch(endpoint, requestOptions)
    .then(response => response.json())
    .then(result => {
      populateHiddenFields(form, {
        network: result.network,
        name: result.name
      });
      return true;
    })
    .catch(error => {
      console.error("ZIP code lookup error:", error);
      // Proceed even if lookup fails
      return false;
    });
};

// Function to populate hidden fields and set the lookup flag
const populateHiddenFields = (form, data) => {
  const networkField = form.querySelector("input[name='00NHp00000o6cHT']");
  const nameField = form.querySelector("input[name='00NHp00000o6cHY']");

  if (networkField) networkField.value = data.network;
  if (nameField) nameField.value = data.name;

  // Set a data attribute or hidden field to indicate lookup is complete
  form.dataset.zipLookupCompleted = "true";
};


// Handle ZIP lookup on blur
document.querySelectorAll('.dist-lookup').forEach(input => {
  input.addEventListener('blur', function() {
    const form = this.closest('form');
    const zipCode = this.value;

    if (zipCode.length >= 5) {
      handleZipLookup(zipCode, form)
        .catch(error => {
          // Optionally, provide feedback to the user if lookup fails
          console.error("Error during ZIP lookup on blur:", error);
        });
    }
  });
});

// Handle form submission
document.querySelectorAll('form').forEach(form => {
  form.addEventListener('submit', function(e) {
    const zipInput = form.querySelector('.dist-lookup');
    const zipCode = zipInput ? zipInput.value : '';
    const lookupCompleted = form.dataset.zipLookupCompleted;

    if (zipInput && zipCode.length >= 5 && !lookupCompleted) {
      e.preventDefault(); // Prevent immediate submission

      handleZipLookup(zipCode, form)
        .finally(() => {
          // Form will be submitted after the lookup attempt completes
          form.removeEventListener('submit', arguments.callee); // Remove the event handler to avoid infinite loop
          form.submit();
        });
    }
  });
});

document.querySelectorAll("input, textarea, select").forEach((element) => {
  element.addEventListener("invalid", function () {
      const message = this.dataset.errorMessage || "This field is required.";
      this.setCustomValidity(message);
  });

  element.addEventListener("input", function () {
      this.setCustomValidity(""); // Reset validation message on user input
  });
});


});